window.addEventListener("DOMContentLoaded", function () {
    function setMegaMenuHeight(targetSelector, subtractSelectors) {
        const windowHeight = window.innerHeight
        const windowWidth = window.innerWidth

        let totalSubtractHeight = 0
        subtractSelectors.forEach((selector) => {
            const element = document.querySelector(selector);
            if (element) {
                totalSubtractHeight += element.offsetHeight
            }
        });

        let targetHeight = (windowHeight - totalSubtractHeight);
        const targetElement = document.querySelector(targetSelector);

        if (targetElement) {
            let height = 'auto !important'
            let overflow = 'hidden !important'

            if (targetHeight <= 520) {
                height = '70vh !important'
                overflow = 'auto !important'
                setStyle(targetElement, height, overflow)
            } else if (targetHeight <= 586) {
                height = '76vh !important'
                setStyle(targetElement, height, overflow)
            } else if (targetHeight >= 600) {
                setStyle(targetElement, height, overflow)
            }
        }
    }

    function setStyle(targetElement, height, overflow) {
        targetElement.setAttribute("style", `height: ${height}; overflow-y: ${overflow};`)
    }

    function isWithinSizeRange() {
        const width = window.innerWidth
        const height = window.innerHeight
        return width >= 1350 && width <= 1600 && height >= 599 && height <= 800
    }

    const headerElement = document.querySelector("header nav ul li:first-child header-menu summary.header__menu-item")
    headerElement.addEventListener("mouseenter", () => {
        if (isWithinSizeRange()) {
            setMegaMenuHeight("#MegaMenu-Content-1", [
                "#shopify-section-custom-top-bar",
                "#shopify-section-header sticky-header"
            ])
        }
    })

    const megaMenu1 = document.querySelector("#MegaMenu-Content-1")
    megaMenu1.addEventListener("mouseleave", () => {
        if (megaMenu1 && isWithinSizeRange()) {
            megaMenu1.setAttribute("style", "")
        }
    })

    window.addEventListener("resize", () => {
        if (isWithinSizeRange()) {
            setMegaMenuHeight("#MegaMenu-Content-1", [
                "#shopify-section-custom-top-bar",
                "#shopify-section-header sticky-header"
            ])
        }
    })

    // Change mattresses from <div> to <li>
    const parentElement = document.querySelector('header #MegaMenu-Content-2')
    const liElements = parentElement.querySelectorAll('ul.mega-menu__list li')

    if (liElements.length === 2) {
        const divElement = parentElement.querySelector('.extended-menu')
        const newLi = document.createElement('li')
        newLi.classList.add('extended-menu__partial', 'extended-menu__partial--accessories')
        newLi.innerHTML = divElement.innerHTML
        liElements[1].insertAdjacentElement('afterend', newLi)
        parentElement.classList.add('altered')
        divElement.remove()
    }
})
